import { googleAnalytics } from "./trackers/googleAnalytics";
import { metaPixel } from "./trackers/metaPixel";
import type { Tracker } from "./types";

/**
 * The full set of trackers the app knows about. Adding a new tracker downstream
 * is a one-line change here (plus its tracker module) — the consent store,
 * banner, and controller all iterate this list generically.
 */
export const TRACKERS: Tracker[] = [googleAnalytics, metaPixel];
